import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

const state = {
  records: [],
  meta: {
    currentPage: 1,
    perPage: 15,
    totalEntries: 0,
  },
  uiFlags: {
    fetchingList: false,
    isDownloading: false,
  },
  appliedFilters: [],
  searchQuery: '',
  currentFilterQuery: null,
  exportType: '',
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
